import PropTypes from 'prop-types';
import React from 'react';
import { Tooltip } from '@weezevent/nacre';

import Styles from '../../../styles/rate/rateBundleInfo.module.css';

import { useTranslation } from 'react-i18next';

export function RateBundleInfo({ bundleSize }) {
    const { t } = useTranslation();

    if (bundleSize <= 1) {
        return null;
    }

    return (
        <Tooltip triggerOnHover={true} title={t('ticket.rates.rateBundleTooltip', { count: bundleSize })} className={Styles['rate-bundle-tooltip']}>
            <div className={Styles['rate-bundle-info']}>
                <span className={Styles['rate-bundle-icon']} />x{bundleSize}
            </div>
        </Tooltip>
    );
}

RateBundleInfo.propTypes = {
    bundleSize: PropTypes.number
};
